import { Context } from '../..';
import { DisplayAreas } from '../../../enums';
import { getUserCompanyVariables, setSubDomain } from './company';
import { getAssignedLearning } from './courses';
import { syncCourseContent } from './data-sync';
import { getUser, logDailyLogin } from './user';
import { getUserPermissions } from './permissions';
import { getForcedAssessments } from './learnerassessment';
import { getNotifications } from './notifications';
import { identify } from '../../../library/helpers/segment';
import { getFreemiumAccount } from './freemium-account';
import { Mode } from '../../../navigation/navigation.enums';

export async function initialiseForeground(context: Context): Promise<void> {
  context.state.isInitialising = true;
  await Promise.all([
    setSubDomain(),
    getUser(context),
    getUserPermissions(context),
    getFreemiumAccount(context),
    getForcedAssessments(context),
    context.state.mode !== Mode.AdminDashboard && getUserCompanyVariables(context)
  ]);
  context.state.isInitialising = false;
}

export async function initialiseBackground(context: Context): Promise<void> {
  await syncCourseContent(context);
  await getAssignedLearning(context);
  await getNotifications(context, {
    size: 20,
    activeOnly: true,
    displayArea: DisplayAreas.EntireApplication,
  });
  await logDailyLogin();
  if (!!context.state.user?.learnerSlug) await identify(context.state.user.learnerSlug, context.state.user);
}
